import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import privateLibraryActions from 'redux/actions/privateLibraryActions'
import { localize } from 'helpers/translator'


const PrivateLibraryAddToMultipleSchoolsConfirm = props => (<Confirm
	btOne={localize('global_no')}
	btTwo={localize('global_yes')}
	alertTitle= {props.alertTitle}
	alertMessage = ''
	actionButtonType={0}
	actionOne={() => props.actions.singleSchool()}
	actionTwo={
		() => {
			props.actions.multipleSchools()
		}
	}
	closeAction={() => props.actions.cancel()} />)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		singleSchool: privateLibraryActions.findLessons_addLessons_singleSchool,
		multipleSchools: privateLibraryActions.findLessons_addLessons_multipleSchools,
		cancel: privateLibraryActions.findLessons_addLessons_multipleSchools_cancel,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(PrivateLibraryAddToMultipleSchoolsConfirm)
